package com.anjuros.website.templates.template9.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.styleModifier
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.w3c.dom.events.EventListener

private var template9RevealCounter = 0

/**
 * Subtle "fade + slide up" animation played once, when the content scrolls into view.
 * [delayMs] lets items in a row appear one after another.
 */
@Composable
fun Template9Reveal(
    modifier: Modifier = Modifier,
    delayMs: Int = 0,
    offsetY: Int = 36,
    contentAlignment: Alignment = Alignment.TopStart,
    content: @Composable () -> Unit
) {
    val elementId = remember { "t9-reveal-${template9RevealCounter++}" }
    var visible by remember { mutableStateOf(false) }

    DisposableEffect(elementId) {
        val check: () -> Unit = {
            if (!visible) {
                val top = document.getElementById(elementId)?.getBoundingClientRect()?.top
                if (top != null && top < window.innerHeight * 0.9) {
                    visible = true
                }
            }
        }
        val listener = EventListener { check() }
        window.addEventListener("scroll", listener)
        window.addEventListener("resize", listener)
        val timeout = window.setTimeout({ check() }, 120)

        onDispose {
            window.clearTimeout(timeout)
            window.removeEventListener("scroll", listener)
            window.removeEventListener("resize", listener)
        }
    }

    Box(
        modifier = modifier
            .id(elementId)
            .opacity(if (visible) 1f else 0f)
            .translateY(if (visible) 0.px else offsetY.px)
            .styleModifier {
                property(
                    "transition",
                    "opacity 800ms ease ${delayMs}ms, translate 800ms cubic-bezier(0.22, 1, 0.36, 1) ${delayMs}ms"
                )
            },
        contentAlignment = contentAlignment
    ) {
        content()
    }
}
